import styled from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const AngledBackground = styled.svg`
  height: 100%;
  width: 200px;
  overflow: hidden;

  ${Media.Below.mobileLarge`
    height: 125px; 
    width: 100%;
    order: 1;
    min-height: 125px;
  `}

  > polygon {
    fill: ${THEME.colors.primaryBackgroundColor};

    ${Media.Below.mobileLarge`
      -webkit-clip-path: polygon(0% 70%, 0% 100%, 100% 100%);
    `}
  }
`;

export const Background = styled.div`
  z-index: -2;
  background: url(${props => `${props.background}`}) no-repeat;
  background-position: right center;
  background-size: auto 100%;
  background-color: black;
  height: 100vh;
  min-height: 750px;
  width: 100vw;
  display: flex;
  align-items: center;
  overflow-x: hidden;

  ${Media.Below.tablet`
    min-height: 700px;
  `}

  ${Media.Below.mobileLarge`
    min-height: 560px;
    background-position: center top;
    background-size: contain;
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const ContentCtn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 385px;
  z-index: 1;
  background-color: ${THEME.colors.primaryBackgroundColor};
  margin: 0 -1px;

  ${Media.Below.mobileLarge`
    justify-content: flex-start;
    padding: 0 3vw;
    margin: -1px 0 0;
    width: 100%;
    min-width: unset;
    order: 2;
    padding-bottom: 20px;
  `}
`;

export const FooterCtn = styled.div`
  position: absolute;
  z-index: 3;
  bottom: 2vh;
  height: 48px;

  ${Media.Below.tablet`
    height: 40px;
  `}

  ${Media.Below.mobileLarge`
    position: static;
    margin-top: 30px;
    order: 3;
    height: 35px;
  `}

  > img {
    height: 100%;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  padding-bottom: 40px;

  ${Media.Below.mobileLarge`
    width: 100%;
  `}
`;

export const LogoImgCtn = styled.div`
  height: 49px;
  margin-top: 15px;
  margin-bottom: 40px;

  ${Media.Below.tablet`
    height: 40px;
    margin-bottom: 20px;
  `}

  ${Media.Below.mobileLarge`
    height: 35px;
    margin-bottom: 5px;
  `}
`;

export const LogoImg = styled.img`
  height: 100%;
  width: auto;
`;

export const LoginPage = styled.div`
  position: relative;
  width: 100%;
  overflow-x: hidden;
`;

export const Spacer = styled.div`
  padding-left: 7vw;
  height: 100%;
  background-color: ${THEME.colors.primaryBackgroundColor};

  ${Media.Below.mobileLarge`
    display: none;
  `}
`;

export const WelcomeText = styled.span`
  font-size: 24px;

  ${Media.Below.mobileLarge`
    font-size: 15px;
  `}
`;
